<template>
    <div class="col-lg-4 col-md-12 mb-4">
        <div v-if="product && !loadingItem" class="card h-100 shadow-lg bg-dark">
            <div class="card-body px-4 py-4">
                <div>
                    <h5 class="card-title text-light">{{ product.name }}</h5>
                    <div>
                        <span class="text-light text-bold h2">{{ toCurrency(selectedPrice / 100)
                        }}</span>
                    </div>
                    <br>
                    <p class="text-light text-left">
                        {{ product.description }}
                    </p>
                </div>
            </div>

            <div class="input-group mb-3 px-4">
                <select class="custom-select" id="inputGroupSelect01" v-model="selectedPriceID">
                    <option v-for="price in product.prices" :key="price.id" :value="price.id">
                        {{ price.nickname }}
                    </option>
                </select>
            </div>
            <div class="card-body text-center d-flex justify-content-between product-actions">
                <button @click="buyNow" class="btn btn-outline-light btn-lg" style="border-radius:30px">Buy
                    Now</button>

                <button @click="addToCart(product)" class="btn btn-outline-light btn-lg" style="border-radius:30px">Add to
                    Cart</button>
            </div>
        </div>

        <div v-if="loadingItem" class="card shadow-lg bg-dark shimmer">
            <div class="card-body px-4 py-4">

            </div>
        </div>
    </div>
</template>

<script>
import { toCurrency } from '../utils/currency';

import { createCheckoutSession, getProductById } from '../services/stripe.service'
import { addToCart } from '../services/cart.service'


export default {
    props: [
        "product_id"
    ],
    data() {
        return {
            product: null,
            selectedPriceID: '',
            selectedPrice: 0,
            loadingItem: true
        }
    },
    methods: {
        addToCart(product) {
            const { username } = this.$store.state.apiEvents;
            if (!username) {
                // Use localstorage as cart
                this.$store.dispatch('cart/addItemToCart', {
                    ...product,
                    selectedPriceID: this.selectedPriceID
                })
            } else {
                // Happens when "add to cart when authed"
                addToCart(this.selectedPriceID, product.id)
                    .then(() => {
                        this.$store.dispatch('cart/addItemToCart', {
                            ...product,
                            selectedPriceID: this.selectedPriceID
                        })
                    })
                    .catch(() => {
                        // add to cart error
                    })
            }
        },
        buyNow() {
            let checkoutSessionObject = {
                "line_items": [
                    {
                        price: this.selectedPriceID, quantity: 1,
                    }
                ],
            }


            if (this.$store.state.apiEvents.username) {
                checkoutSessionObject = {
                    ...checkoutSessionObject,
                    customer_email: this.$store.state.apiEvents.username
                }
            }

            // Call api to add to cart
            createCheckoutSession(checkoutSessionObject)
                .then(({ data: checkoutData }) => {
                    window.location.href = checkoutData.url
                })
                .catch((err) => {
                    // toast error
                })

        },
        toCurrency
    },
    mounted() {
        getProductById(this.$props.product_id, "prices")
            .then(({ data }) => {
                this.product = data
                this.selectedPriceID = data.default_price.id
            })
            .finally(() => {
                this.loadingItem = false
            })
    },
    watch: {
        selectedPriceID: function (val) {
            if (this.product) {
                const findPriceByID = this.product.prices.find((price) => price.id === val)
                this.selectedPrice = findPriceByID.unit_amount
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    border: none;
}

.card::after {
    position: absolute;
    z-index: -1;
    opacity: 0;
    -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.card:hover {
    transform: scale(1.02, 1.02);
    -webkit-transform: scale(1.02, 1.02);
    backface-visibility: hidden;
    will-change: transform;
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, .75) !important;
}

.card:hover::after {
    opacity: 1;
}

.card:hover {
    color: black;
    background: #007bff;
}

.product-actions {
    max-height: 85px;
}

$light: rgb(139, 139, 139);
$dark: rgb(116, 114, 114);

@keyframes shimmering {
    0% {
        background-position: -1300px 0;
    }

    100% {
        background-position: 1300px 0;
    }
}

.shimmer {
    height: 30vh;
    animation: shimmering 3.1s linear infinite;
    background: $dark;
    background: linear-gradient(90deg, $dark 9%, $light 18%, $dark 31%);
    background-size: 1300px 100%;
}
</style>